import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import {
  formatMoneda,
  formatoMonto,
  seleccionarCampo,
  TIPODEUDA,
  validaMonto,
} from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import useTableScroll from "../useTableScrollcesar";
import { TableBody, TableCell, TableRow } from "@material-ui/core";
import { ModalCrearDeudaMina } from "./modalCrearDeudaMina";

export const ModalActualizarDeudaMina = (props) => {
  const op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const dirip = JSON.parse(localStorage.getItem("ip"));
  const dirmac = JSON.parse(localStorage.getItem("mac"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const TITULO = {
    1: "Crear Deuda Mina",
    2: "Ajustar Deuda Mina",
    3: "Actualizar Deuda Mina",
    4: "Eliminar Deuda Mina",
  };
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtMonto = useRef();
  const txtFactura = useRef();
  const cmbTipo = useRef();

  const [activate, setActivate] = useState(false);
  const [show, setShow] = useState({
    mostrar: false,
    tipo: 1,
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [records, setRecords] = useState([]);
  const headCells = [
    { label: "Tipo", textAlign: "center" },
    { label: "Año", textAlign: "center" },
    { label: "Mes", textAlign: "center" },
    { label: "Monto", textAlign: "center" },
    { label: "Interes Mora", textAlign: "center" },
    { label: "Recargo", textAlign: "center" },
    { label: "Multa", textAlign: "center" },
    { label: "Descuento", textAlign: "center" },
    { label: "Total", textAlign: "center" },
    { label: "", textAlign: "center" },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    let sigue = true;

    if (props.operacion === 3) {
      if (txtFactura.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "El Campo Factura No Puede Estar Vacio.",
          icono: "informacion",
        });
        sigue = false;
        txtFactura.current.focus();
      }
    }

    if (sigue) {
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro De Crear La Deuda Con Estos Datos?.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro De Ajustar La Deuda Con estos Datos?.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro De Acualizar La Deuda Con Estos Datos?.";
      } else if (props.operacion === 4) {
        msg = "Esta Seguro De Eliminar La Deuda Con Estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    const endpoint = `${op.conexion}/api/deuda/actualizardeuda`;
    const body = {
      operacion: props.operacion,
      txtagente: props.agente.idagente,
      arraydeuda: records,
      txtmonto:
        props.operacion === 2
          ? parseFloat(
              txtMonto.current.value.trim().replace(/\./g, "").replace(",", ".")
            )
          : 0.0,
      txtfactura: props.operacion === 3 ? txtFactura.current.value : "",
      fechasis: fechaSistema,
      idusu: idusuario,
      dirip: dirip,
      dirmac: dirmac,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "La Deuda Se Creo Exitosamente.",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "La Deuda Se Ajusto Exitosamente.",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "La Deuda Se Actualizo Exitosamente.",
              icono: "exito",
            });
          } else if (props.operacion === 4) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "La Deuda Se Elimino Exitosamente.",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleCloseSi = () => {
    Actualizar();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarModal = () => {
    props.onHide(true);
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cancelar = () => {
    props.onHide();
  };

  const eliminarItem = (index) => {
    let d = [];
    for (let i = 0; i < records.length; i++) {
      if (index !== i) {
        d.push(records[i]);
      }
    }
    setRecords(d);
  };

  const onHide = (deu = "") => {
    setShow({
      ...show,
      mostrar: false,
    });
    if (deu !== "") {
      let d = [...records];

      console.log(deu);
      

      for (let i = 0; i < d.length; i++) {
        for (let j = 0; j < deu.length; j++) {
          if (deu[j].anio === d[i].anio && deu[j].nummes === d[i].nummes && deu[j].tipodeuda === d[i].tipodeuda) {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: `Ya Existe Una Deuda Con EL Periodo: ${deu[j].anio}-${deu[j].mes}`,
              icono: "informacion",
            });
            return;
          }
        }
      }

      setRecords(d.concat(deu));
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.operacion === 1) {
          setRecords([]);
        } else {
          setRecords(props.deuda);
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>{TITULO[props.operacion]}</h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        {props.operacion === 1 && (
          <div className="row col-md-12 d-flex justify-content-end">
            <div className="col-8 input-group mb-3">
              <label className="input-group-text" htmlFor="comboano">
                Tipo:
              </label>
              <select
                ref={cmbTipo}
                onChange={(e) => {
                  setShow({
                    ...show,
                    tipo: e.target.value,
                  });
                }}
                className="form-select"
                id="tipo"
              >
                <option key={1} value={"1"}>
                  DECLARACION MINA
                </option>
                <option key={2} value={"11"}>
                  MULTA
                </option>
                <option key={3} value={"111"}>
                  TASA
                </option>
                <option key={4} value={"23"}>
                  IMPUESTO SUPERFICIAL
                </option>
                <option key={5} value={"24"}>
                  VENTAJAS ESPECIALES
                </option>
                <option key={6} value={"25"}>
                  GUIAS
                </option>
              </select>
            </div>
            <div className="col-3 d-flex justify-content-end">
              <button
                style={{ marginBottom: "5px" }}
                onClick={() =>
                  setShow({
                    ...show,
                    mostrar: true,
                  })
                }
                className="btn btn-sm btn-primary rounded-circle"
              >
                <i className="fas fa-plus"></i>{" "}
              </button>
            </div>
          </div>
        )}
        <div className="row col-md-12 justify-content-between mt-3">
          <TblContainer
            container={{
              height: 200,
              maxHeight: 200,
              width: "100%",
              overflow: "auto",
            }}
          >
            <TblHead />
            <TableBody>
              {records &&
                records.map((deu, index) => (
                  <TableRow key={index}>
                    <TableCell className="p-0 text-center">
                      {TIPODEUDA[deu.tipodeuda]}
                    </TableCell>
                    <TableCell className="p-0 text-center">
                      {deu.anio}
                    </TableCell>
                    <TableCell className="p-0 text-center">{deu.mes}</TableCell>
                    <TableCell className="p-0 text-end">
                      {formatMoneda(
                        deu.monto.toString().replace(",", "").replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                    </TableCell>
                    <TableCell className="p-0 text-end">
                      {formatMoneda(
                        deu.intereses
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                    </TableCell>
                    <TableCell className="p-0 text-end">
                      {formatMoneda(
                        deu.recargo
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                    </TableCell>
                    <TableCell className="p-0 text-end">
                      {formatMoneda(
                        deu.multa.toString().replace(",", "").replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                    </TableCell>
                    <TableCell className="p-0 text-end">
                      {formatMoneda(
                        deu.credito
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                    </TableCell>
                    <TableCell className="p-0 text-end">
                      {formatMoneda(
                        deu.total.toString().replace(",", "").replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                    </TableCell>
                    <TableCell className="p-0 text-center">
                      <button
                        onClick={() => eliminarItem(index)}
                        className="btn btn-sm  btn-danger rounded-circle ml-2"
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>

          {props.operacion > 1 && props.operacion < 4 && (
            <fieldset className="row border-azul m-3 rounded mx-auto col-sm-12 justify-content-between">
              {props.operacion === 2 && (
                <div style={{ width: 250 }} className="input-group m-3">
                  <label className="input-group-text" id="monto">
                    Monto:
                  </label>
                  <input
                    type="text"
                    style={{ minHeight: "100%" }}
                    defaultValue={"0,00"}
                    ref={txtMonto}
                    disabled={props.operacion >= 3}
                    onFocus={seleccionarCampo}
                    onBlur={handleInputMontoChange}
                    onKeyUp={handleInputMontoChange}
                    className="form-control text-end"
                    aria-label="campo monto"
                    aria-describedby="monto"
                  />
                </div>
              )}

              {props.operacion === 3 && (
                <div style={{ width: 250 }} className="input-group m-3">
                  <label className="input-group-text" id="monto">
                    N° Factura:
                  </label>
                  <input
                    type="text"
                    ref={txtFactura}
                    style={{ minHeight: "100%" }}
                    defaultValue={""}
                    disabled={props.operacion !== 3}
                    className="form-control uppercase"
                    aria-label="campo numero factura"
                    aria-describedby="factura"
                  />
                </div>
              )}
            </fieldset>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          ref={btnAcepta}
          onClick={onChangeValidar}
          style={{ margin: "1px" }}
          className="fw-bold btn btn-success btn-sm rounded-pill"
        >
          <i className="far fa-check-circle"></i> Aceptar
        </button>
        <button
          type="button"
          ref={btnCancela}
          onClick={cancelar}
          style={{ margin: "1px" }}
          className="fw-bold btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"></i> Cancelar
        </button>
      </Modal.Footer>

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />

      <ModalCrearDeudaMina
        show={show.mostrar}
        tipo={show.tipo}
        operacion={props.operacion}
        agente={props.agente}
        onHide={onHide}
      />
      <Dimmer active={activate} />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/minas/modalActualizarDeudaMina.js